import Vue from 'vue';
import Router from 'vue-router';
import enumeraciones from '@/../static/js/enumeraciones'
import { store } from '@/store/index';

//Se realiza el import de los comunes
import Comun from '@/router/Comun';

//Se realizan los imports de los sistemas
//-----------SISTEMAS-----------
import PaginaOficial from '@/router/PaginaOficial';
import Forseti from '@/router/Forseti';
import FirmaElectronica from '@/router/FirmaElectronica'
import TemisCivil from '@/router/TemisCivil'
import SISETA from '@/router/SISETA'
import DiasHabiles from '@/router/DiasHabiles'
import SIAP from '@/router/SIAP'
import SISEVA from '@/router/SISEVA'
import SICPO from '@/router/SICPO'
import Micrositios from '@/router/Micrositios'
import ArchivoJudicial from '@/router/ArchivoJudicial'
import SINOJ from '@/router/SINOJ'
import EQUITAS from '@/router/EQUITAS'
import SICUS from '@/router/SICUS'
import SICCIJ from '@/router/SICCIJ'
import SICSEN from '@/router/SICSEN'
import Intranet from '@/router/Intranet'
import SIPSIC from '@/router/SIPSIC'
import SIQA from '@/router/SIQA'
import SIFA from '@/router/SIFA'
import Audiencias from '@/router/AudienciasTemporal'
import AudienciasMonitor from '@/router/AudienciasMonitor'
import SICPE from '@/router/SICPE'
import SIVAC from '@/router/SIVAC'
import CONVOCATORIAS from '@/router/ConvocatoriasAdministrador'

//Se crea el listado de rutas de los importados
const routes = [];
crearLasRutasDelSistema(Comun);
crearLasRutasDelSistema(PaginaOficial);
crearLasRutasDelSistema(Forseti);
crearLasRutasDelSistema(FirmaElectronica);
crearLasRutasDelSistema(TemisCivil);
crearLasRutasDelSistema(SISETA);
crearLasRutasDelSistema(DiasHabiles);
crearLasRutasDelSistema(SIAP);
crearLasRutasDelSistema(SISEVA);
crearLasRutasDelSistema(SICPO);
crearLasRutasDelSistema(ArchivoJudicial);
crearLasRutasDelSistema(SINOJ);
crearLasRutasDelSistema(EQUITAS);
crearLasRutasDelSistema(Micrositios);
crearLasRutasDelSistema(SICUS);
crearLasRutasDelSistema(SICCIJ);
crearLasRutasDelSistema(SICSEN);
crearLasRutasDelSistema(Intranet);
crearLasRutasDelSistema(SIPSIC);
crearLasRutasDelSistema(SIQA);
crearLasRutasDelSistema(SIFA);
crearLasRutasDelSistema(Audiencias);
crearLasRutasDelSistema(AudienciasMonitor);
crearLasRutasDelSistema(SICPE);
crearLasRutasDelSistema(SIVAC);
crearLasRutasDelSistema(CONVOCATORIAS);

//Se llama el router de Vue
Vue.use(Router);


//Se crean los llamados de router y sus acciones previas
const vueRouter = new Router({
  mode: 'history',
  routes
});

//beforeResolve
vueRouter.beforeEach(async (to, from, next) => {
  await procesamientoDelTipoDeValidacion(to)
    .then(respuesta => {
      store.state.Login_TareasCumplidas = {
        ValidaSesion: null,
        ObtenDatos: null,
        ObtenPermisosDelSistema: null,
        ObtenPermisoDeLaVentana: null,
        ObligarAMoverseAAlgunaPagina: null
      }
      store.state.Login_PaginaPrevia = from;
      
      return respuesta;
    })
    .then(respuesta => {
      document.title = to.meta.tituloDeLaPagina ? to.meta.tituloDeLaPagina + " - Poder Judicial del Estado de Aguascalientes" : 'Poder Judicial del Estado de Aguascalientes';
      if(to.fullPath == "/") {
        next({
          path: '/Inicio'
        });  
      }

      switch(respuesta) {
        case enumeraciones.RutaEsRedirigidaPor.EsCasa:
          if(to.fullPath == "/")
            next({
              path: '/Inicio'
            });
          break;
        case enumeraciones.RutaEsRedirigidaPor.NoTieneSesion:
          if(to.fullPath != "/Login")
            next({
              path: '/Login'
            });
          else
            next();
          break;
        case enumeraciones.RutaEsRedirigidaPor.YaTieneSesion:
          if(to.fullPath.search("Tablero") < 0 || to.fullPath == "/Tablero") {
            next({
              path: "/Tablero/Bienvenida"
            })
          } else if(to.fullPath == "/Login") {
            next({
              path: "/Tablero/Bienvenida"
            })
          } else
            next();
          break;
        case enumeraciones.RutaEsRedirigidaPor.NoTieneAccesoAlSistema:
          if(from != undefined)
            next(from);
          else {
            if(to.fullPath.search("Tablero") < 0 || to.fullPath == "/Tablero") {
              next({
                path: "/Tablero/Bienvenida"
              })
            } else
              next();
          }
          break;
        case enumeraciones.RutaEsRedirigidaPor.NoTieneAccesoALaVentana:
          if(from != undefined)
            next(from);
          else {
            if(to.fullPath.search("Tablero") < 0 || to.fullPath == "/Tablero") {
              next({
                path: "/Tablero/Bienvenida"
              })
            } else
              next()
          }
          break;
        case enumeraciones.RutaEsRedirigidaPor.NoEsRedirigida:
          next()
          break;
        default:
          next({
            path: "/PaginaNoEncontrada"
          });
          break;
      }
    });
});

//Se hace la asignación y export de las rutas a Vue
export default vueRouter;

//Se define la función que se encargara de hacer el listado de todos los paths
function crearLasRutasDelSistema(datosDeLosPaths) {
  for (let i = 0; i < datosDeLosPaths.length; i++) {
    routes.push(datosDeLosPaths[i]);
  }
}

async function procesamientoDelTipoDeValidacion(to) {
  return new Promise(async resultado => {
    store.state.Login_Meta = to.meta;
   
    if(to.fullPath.search("Login") >= 0) {
      resultado(await procesamientoDeLasReglasDeLogin(to.meta));
    } else if (to.fullPath.search("Tablero") >= 0) {
      resultado(await procesamientoDeLasReglasDeTablero(to.meta));
    } else {
      if (to.matched.some(record => record.meta.RequiereAutenticacion)) {
        resultado(await procesamientoDeLasReglasDeSistema(to.meta));
      } else {
        resultado(enumeraciones.RutaEsRedirigidaPor.NoEsRedirigida);
      }
    }
  })
  .then(respuesta => {
    return respuesta;
  });
}

//Se encarga de procesar la información en dado caso de ser login
async function procesamientoDeLasReglasDeLogin(parametros) {
  store.state.Login_Usuario = {
    TituloYNombreCompleto: "Sin usuario",
    Foto: null,
    Iniciales: null,
    MenuPrincipal: [],
    Sistemas: []
  };
  
  store.state.Login_SeHaPreguntadoIniciarSesion = false;
  store.state.Login_PermisosDelSistema = [];

  if(store.state.Login_TiempoDeVerificacionId != null) {
    clearInterval(store.state.Login_TiempoDeVerificacionId);
    store.state.Login_TiempoDeVerificacionId = null;
  }
  
  return await obtenLosResultadosDeRuteo(parametros);
}

//Se encarga de procesar la información en dado caso de ser Tablero
async function procesamientoDeLasReglasDeTablero(parametros) {
  return await obtenLosResultadosDeRuteo(parametros);
}

//Se encarga de procesar la información en dado caso de ser Sistema
async function procesamientoDeLasReglasDeSistema(parametros) {
  return await obtenLosResultadosDeRuteo(parametros);
}

async function obtenLosResultadosDeRuteo(parametros) {
  return new Promise(async (resultado, rechazo) => {
    resultado(await store.dispatch("A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema", parametros));
  })
  .then(respuesta => {
    return procesarLasReglasDelRuteo(respuesta == undefined ? store.state.Login_TareasCumplidas : respuesta);
  })
}

//Se procesa que tipo de ruteo se realizara
function procesarLasReglasDelRuteo(respuesta) {
  if(respuesta != undefined) {
    if(respuesta.ObligarAMoverseAAlgunaPagina != null)
      return respuesta.ObligarAMoverseAAlgunaPagina;
    else {
      if(respuesta.ValidaSesion == false)
      return enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;

      if(respuesta.ObtenDatos == false)
        return enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;

      if(respuesta.ObtenPermisosDelSistema == false)
        return enumeraciones.RutaEsRedirigidaPor.NoTieneAccesoAlSistema;

      if(respuesta.ObtenPermisoDeLaVentana == false)
        return enumeraciones.RutaEsRedirigidaPor.NoTieneAccesoALaVentana;
    }

    return enumeraciones.RutaEsRedirigidaPor.NoEsRedirigida;
  } else {
    return enumeraciones.RutaEsRedirigidaPor.NoEsRedirigida;
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js